"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowDrawer = void 0;
var react_1 = __importDefault(require("react"));
var NavigationDrawerStyles_1 = require("./NavigationDrawerStyles");
// Makes possible moving contents right on opening the <code>NavigationDrawer</code>
exports.FollowDrawer = function (_a) {
    var children = _a.children, open = _a.open;
    return react_1.default.createElement("div", { style: open ? NavigationDrawerStyles_1.paddingForDrawer : NavigationDrawerStyles_1.paddingForClosedDrawer }, children);
};
exports.default = exports.FollowDrawer;
//# sourceMappingURL=FollowDrawer.js.map